<template lang="jade">
	.map-item(:class="data.className")
		.map-item_title(v-if="title") {{ title }}
		MapSVG(v-if="geodata", :geodata="geodata", :year="year", :width="data.width", :height="data.height", :initialScale="data.scale", :centerPoint="data.center", :zoomScale="data.zoomscale", :filters="filters", :responsive="data.responsive")
</template>
<script>
	import MapSVG from './MapSVG.vue';

	export default {
		name: "map-item",
		props: {
			data: {
				type: Object,
				required: true
			},
			filters: {
				type: Object
			},
			/* geodata: {
				type: Object
			},*/
			year: {},
			triggerLoad: {
				type: Boolean
			}
		},
		computed: {
			title() {
				return this.data.title;
			},
			isLoading() {
				return this.$store.state.loading;
			},
			geodata() {
				return this.$store.getters.map(this.year);
			}
		},
		components: { MapSVG },
		mounted() {
			console.log('mounted', this)
			if (this.triggerLoad) {
				this.$store.dispatch('loadMap', this.year);
				this.$store.dispatch('loadResults', this.year);

			}
		}
	}
</script>
<style lang="scss">
	@import "src/_commons/assets/scss/global-sass";

	.map-item {
		// position: relative;
		// flex-basis: 100%;
		// width:100%;

		&.loading &_container {
			border: 2px solid red;
		}

		&_title {
			@include tgs-font-title-xs;
			padding-bottom: $m-spacing-x2;
		}
	}


</style>



// WEBPACK FOOTER //
// MapItem.vue?f1033b8c